<template>
  <div class="agent-app-card-wrapper">
    <el-card>
      <div slot="header">
        应用名：{{  agentApp.app_store_detail.app_name_i18n[0].name  }}
      </div>

      <div class="agent-app-info">
        <div class="label-info">
          <p>应用分类:</p>
          <p>{{ agentApp.app_store_detail.app_category_name_i18n[0].name }}</p>
        </div>
        <div class="label-info">
          <p>开始时间:</p>
          <p>{{ agentApp.start_at | dateformat }}</p>
        </div>
        <div class="label-info">
          <p>过期时间:</p>
          <p>{{ agentApp.expire_at | dateformat }}</p>
        </div>
      </div>

      <div class="agent-app-op">
        <el-button
          type="text"
          @click="onEditClick">修改</el-button>
        <el-button
          type="text"
          class="danger-text"
          @click="onDeleteClick">删除</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AgentAppCard',
  props: {
    agentApp: {
      type: Object,
      required: true
    }
  },
  methods: {
    onEditClick () {
      this.$emit('edit', this.agentApp)
    },
    onDeleteClick () {
      this.$emit('delete', this.agentApp)
    }
  }
}
</script>

<style lang="scss" scoped>

.agent-app-card-wrapper {
  width: 23%;
  padding: 10px;

  .agent-app-info {

    .label-info {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    p {
      line-height: 1.5;
      margin: 0;
    }
  }

  .agent-app-op {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/AgentAppCard.vue